import './index.scss';
import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import { VisibilityProvider } from './provider/state-manager/visibilityProvider';
import {ApiProvider} from './provider/API/call-service'
import { AppInfoProvider } from './provider/state-manager/appInfoProvider';
import { AppRoutes } from 'src/app/app.routing'
import reportWebVitals from './reportWebVitals';
// import NotifierComponents from 'react-pop-notifier';
// const { NotifierProvider } = NotifierComponents;
import { NotifierProvider } from 'react-pop-notifier';

const root = createRoot(document.getElementById("root"));

root.render(
  <StrictMode>
    <NotifierProvider>
      <VisibilityProvider>
        <AppInfoProvider>
          <ApiProvider>
            <AppRoutes />
          </ApiProvider>
        </AppInfoProvider>
      </VisibilityProvider>
    </NotifierProvider>
  </StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
